import { render } from "./CallPopupComponent.vue?vue&type=template&id=3be39f11&scoped=true"
import script from "./CallPopupComponent.vue?vue&type=script&lang=js"
export * from "./CallPopupComponent.vue?vue&type=script&lang=js"

import "./CallPopupComponent.vue?vue&type=style&index=0&id=3be39f11&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be39f11"]])

export default __exports__